import React from 'react';

import Layout from '../../components/horticulture/layout';
import Image from '../../components/horticulture/image';
import SplashText from '../../components/horticulture/splash-text';
import Badges from '../../components/horticulture/badges';
import Section from '../../components/horticulture/section';
import GaugeIcon from '../../svgs/horticulture/gauge-icon.svg';
import CalendarIcon from '../../svgs/horticulture/calendar-with-a-clock-time-tools.svg';
import PhoneIcon from '../../svgs/horticulture/phone-icon.svg';
import MonitorImages from '../../components/horticulture/monitor-images';
import NotifyImages from '../../components/horticulture/notify-images';
import PmpDemoLink from '../../components/horticulture/pmp-demo-link';

const IndexPage = () => (
  <Layout>
    <div style={{ maxWidth: '100%', marginBottom: '1.45rem' }}>
      <Image />
      <SplashText />
      <Badges />
      <Section
        id="monitor"
        headerImage={<GaugeIcon style={{ width: 30, height: 30 }} />}
        header={<>Monitor</>}
        headerStyle={{ background: '#006080', color: 'white' }}
      >
        <div>
          <p />
          <h2>Power Metering Panel</h2>
          <p>
            Monitoring means data and with data you can make better decisions.
            Our panels create unique visibility into your electrical system that
            has never been offered before. By monitoring the power use of each
            branch circuit we can provide granular data of your entire
            operation. If a bulb blows, we will know; If a fan does not operate,
            we will know. With our panels monitoring your system you will gain
            new insights into how well your system operates.
          </p>
          <PmpDemoLink />
          <MonitorImages />
        </div>
      </Section>
      <Section
        id="control"
        headerImage={<CalendarIcon style={{ width: 30, height: 30 }} />}
        header={<>Control</>}
        headerStyle={{ background: '#26734d', color: 'white' }}
      >
        <div>
          <p>
            Growing has become an exact science, but the controls are left in
            the past. Growing environments where light energy, plant nutrition
            and the atmospheric conditions are all in check for the optimal
            conditions. We can provide you state of the art controls for:
          </p>
          <ul>
            <li>
              Comprehensive lighting controls, from grow lights to night lights,
              including dimming controls.
            </li>
            <li>
              Air flow controls, including Volumetric Air Movement Systems
            </li>
            <li>Ventilation controls</li>
            <li>Irrigation and water flow including misting controls</li>
            <li>Fertilization and fertigation controls</li>
            <li>
              CO<sub>2</sub> Optimization
            </li>
            <li>VPD Optimization</li>
            <li>Odor controls</li>
          </ul>
          <h2>Compass Control</h2>
          <p>
            Compass Control provides YOU with the flexibility to optimize your
            growing conditions. We simply provide you with a platform to access
            these details. All from a single comprehensive integrated control
            platform that is leveraging the control of power flow!
          </p>
        </div>
      </Section>
      <Section
        id="notify"
        headerImage={<PhoneIcon style={{ width: 30, height: 30 }} />}
        header={<>Notify</>}
        headerStyle={{ background: '#804d00', color: 'white' }}
      >
        <div>
          <p>
            Your system has been designed to operate in near-perfect conditions.
            We understand that things go wrong - lights fail, fans fail, valves
            fail. Compass Control takes the term "compass", which is a device
            that looks in all directions, and applies that in combination with
            unique control algorithms that result in a comprehensive control
            architecture for the greenhouse/greenroom/grow room environments.
            What we do is provide you with an ever-vigilant monitor that will
            keep an eye on your operations 24/7/365 and let you know when and
            even more importantly - what needs attention. Restoring operations
            to the near-perfect conditions results in improved efficiency, crop
            yields, and quality - which is how your system was originally
            designed to perform. We can keep your system with that "new car"
            smell for the life of it's operation.
          </p>
          <h2>Compass Enterprise</h2>
          <p>
            Compass Enterprise enables the interrogation of multiple power
            monitored and controlled panelboards from a single IP address. You
            don't have to remember all of the addresses for all of the panels so
            that management of your enterprise is incredibly simple. The
            Enterprise hardware and software take care of all the network
            management and control for you. You get a system graphical overview
            of YOUR system layout so that it makes the most sense to your
            operations personnel. We take a highly complex system and make it
            easy to understand and even easier to respond to issues as they
            develop (and you know that issues will develop!)
          </p>
          <NotifyImages />
          {/* <p>
            <strong>link to enterprise demo</strong>
          </p>*/}
        </div>
      </Section>
    </div>
  </Layout>
);

export default IndexPage;
